import { API_KEY } from "src/constants";
import {GET_NARUHONE_DATA,  GET_GOALS, TOGGLE_DAILIES, USERNAME_CHECK, USERNAME_SIGNUP, GET_DASHBOARD_HOMEPAGE, GET_HOMEPAGE_VERSION, GET_USER_DASHBOARDS, GET_MY_USER_DATA, SEND_PUBLIC_MESSAGE, EDIT_DASHBOARD, GET_WANIKANI, GET_PUBLIC_MESSAGE } from "./apiEndpoints";

const createCommonHeader = () =>{
  return {
    'Content-Type': 'application/json', // Adjust content type as needed
    'api-key': API_KEY || "nokey"
  };
}
const createCommonAuthHeader = (token) => ({
  ...createCommonHeader(),
  Authorization: `Bearer ${token}`
})

const apiServices = {
    goal:{
        updateDailies : async (token, dailyGoalsToApi) => {
            const response = await fetch(TOGGLE_DAILIES, {
            method: 'POST',
            headers: createCommonAuthHeader(token),
            body: JSON.stringify({"dailyGoals":dailyGoalsToApi}), // Convert data to JSON string
          });
        
          if (!response.ok) {
            throw new Error('Failed to update dailies');
            }
            return response.json();
        },
        getGoals : async (token) => {
            const response = await fetch(GET_GOALS, {
                method: 'GET',
                headers: createCommonAuthHeader(token)
              });
              if (!response.ok) {
                throw new Error('Failed to get goals');
                }
                return response.json();
        }
    },
    dashboard:{
      getHomePage : async () => {
        const response = await fetch(GET_DASHBOARD_HOMEPAGE , {
          method: 'GET',
          headers: createCommonHeader(),
        });
        return response.json();
      },
      getHomePageVersion: async () => {
        const response = await fetch(GET_HOMEPAGE_VERSION , {
          method: 'GET',
          headers: createCommonHeader(),
        });
        return response.json();
      },

      getUserDashboards : async(username) => {
        const response = await fetch(GET_USER_DASHBOARDS + `/${username}`, {
          method: 'GET',
            headers: createCommonHeader(),
        });
        return response.json();
      },
      sendPublicMessage: async(username, message) => {
        const response = await fetch(SEND_PUBLIC_MESSAGE, {
          method: 'POST',
          headers: createCommonHeader(),
          body: JSON.stringify({username:username, message:message}), // Convert data to JSON string
        });
          return response;
      },
      getPublicMessages:async(username, message) => {
        const response = await fetch(GET_PUBLIC_MESSAGE, {
          method: 'GET',
          headers: createCommonHeader(),
         // Convert data to JSON string
        });
          return response.json();
      }, 
      editDashboard: async(token, dashboardId, dashboardData) => {
        const response = await fetch(EDIT_DASHBOARD, {
          method: 'POST',
          headers: createCommonAuthHeader(token),
          body: JSON.stringify({dashboardId:dashboardId, dashboardData:dashboardData}), // Convert data to JSON string
        });
          return response.json();
      },

    },
    naruhone:{
      getWanikaniData: async () => {
        const response = await fetch(GET_WANIKANI,{
          method: 'GET',
          headers: createCommonHeader(),
        })
        return response.json();
      },
      getNaruhoneData: async () => {
        const response = await fetch(GET_NARUHONE_DATA,{
          method: 'GET',
          headers: createCommonHeader(),
        })
        return response.json();
      }
    },
    
    auth:{
        usernameCheck: async (username) => {
            const response = await fetch(USERNAME_CHECK + `?username=${username}`, {
                method: 'GET',
                headers: createCommonHeader(),
              });
              if (!response.ok) {
                throw new Error('Failed username check');
                }
                return response.json();
        },
        signUp: async (username, token) => {
          const response = await fetch(USERNAME_SIGNUP, {
              method: 'POST',
              headers: createCommonAuthHeader(token),
              body: JSON.stringify({"username":username})
            });
            if (!response.ok) {
              throw new Error('Failed signup');
              }
              return response.json();
      },
      getMyUserData: async (token) =>{
        const response = await fetch(GET_MY_USER_DATA, {
          method: 'POST',
          headers: createCommonAuthHeader(token),
          body: JSON.stringify({})
        });
        if (!response.ok) {
          throw new Error('Failed userdata');
          }
          return response.json();
      }
    }
}


export default apiServices;